import React from 'react';
import './Projects.css';
import AOS from "aos";
import "aos/dist/aos.css";
import ParticlesBg from 'particles-bg';


AOS.init();

const Projects = () => {
    return (
        <>
        <div className="container">
            <div className="row">
                <div className="col-md-4 col-sm-8 card-wrapper">
                    <div data-aos="fade-left" data-aos-delay="20" data-aos-duration="1000" data-aos-easing="ease-in-sine">
                        <div className="card  my-4">
                            <div className="card-img-wrapper m-2">
                                <img className="card-img-top" src="https://i.ibb.co/hRR5rkK/ema-john.png" alt="Card cap" rel="noreferrer"/>
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">E-commerce Site</h5>
                                <div className="card-content">
                                    <p className="card-text">A dynamic full stack e-commerce web application that has authentication with private route and payment gateway API</p>
                                    <a href="https://github.com/saakeeb/ema-john-simple" class="btn btn-primary p-2 m-2" target="_blank" rel="noreferrer">Server</a>
                                    <a href="https://ema-john-simpl.web.app/" class="btn btn-primary p-2 m-2" target="_blank" rel="noreferrer">Website</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-4 col-sm-8 card-wrapper">
                    <div data-aos="fade-left" data-aos-delay="20" data-aos-duration="1500" data-aos-easing="ease-in-sine">
                        <div className="card  my-4">
                            <div className="card-img-wrapper m-2">
                                <img className="card-img-top" src="https://i.ibb.co/8N0Mpzg/user-post.png" alt="Card cap" rel="noreferrer"/>
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">Public Post</h5>
                                <div className="card-content">
                                    <p className="card-text">A dynamic web application with material UI design and route for public comments</p>
                                    <a href="https://github.com/saakeeb/material-ui-react" class="btn btn-primary p-2 m-2" target="_blank" rel="noreferrer">Server</a>
                                    <a href="https://userposts.netlify.app/" class="btn btn-primary p-2 m-2" target="_blank" rel="noreferrer">Website</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-4 col-sm-8 card-wrapper">
                    <div data-aos="fade-left" data-aos-delay="20" data-aos-duration="2000" data-aos-easing="ease-in-sine">
                        <div className="card  my-4">
                            <div className="card-img-wrapper m-2">
                                <img className="card-img-top" src="https://i.ibb.co/n8PRn8s/odami.png" alt="Card cap" rel="noreferrer" />
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">Course Curriculum</h5>
                                <div className="card-content">
                                    <p className="card-text">A dynamic web application with bootstrap design for course curriculum</p>
                                    <a href="https://github.com/saakeeb/odami-course" class="btn btn-primary p-2 m-2" target="_blank" rel="noreferrer">Server</a>
                                    <a href="https://odami.netlify.app/" class="btn btn-primary p-2 m-2" target="_blank" rel="noreferrer">Website</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <br/> */}

                <div className="col-md-4 col-sm-8 card-wrapper">
                    <div data-aos="fade-right" data-aos-delay="20" data-aos-duration="2000" data-aos-easing="ease-in-sine">
                        <div className="card  my-4">
                            <div className="card-img-wrapper m-2">
                                <img className="card-img-top" src="https://i.ibb.co/x7TQ0fQ/weather.png" alt="Card cap" rel="noreferrer"/>
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">City Weather</h5>
                                <div className="card-content">
                                    <p className="card-text">A single page web application with API for city weather</p>
                                    <a href="https://github.com/saakeeb/weatherApi" class="btn btn-primary p-2 m-2" target="_blank" rel="noreferrer">Server</a>
                                    <a href="https://saakeeb.github.io/weatherApi/?" class="btn btn-primary p-2 m-2" target="_blank" rel="noreferrer">Website</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-4 col-sm-8 card-wrapper">
                    <div data-aos="fade-right" data-aos-delay="20" data-aos-duration="1500" data-aos-easing="ease-in-sine">
                        <div className="card  my-4">
                            <div className="card-img-wrapper m-2">
                                <img className="card-img-top" src="https://i.ibb.co/QYyYtSW/lyrics.png" alt="Card cap"  rel="noreferrer" />
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">Search Lyrics</h5>
                                <div className="card-content">
                                    <p className="card-text">A single page web application with lyrics API for music lovers</p>
                                    <a href="https://github.com/saakeeb/hard-rock-lyrics" class="btn btn-primary p-2 m-2" target="_blank" rel="noreferrer">Server</a>
                                    <a href="https://saakeeb.github.io/hard-rock-lyrics/" class="btn btn-primary p-2 m-2" target="_blank" rel="noreferrer">Website</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-4 col-sm-8 card-wrapper">
                    <div data-aos="fade-right" data-aos-delay="20" data-aos-duration="1000" data-aos-easing="ease-in-sine">
                        <div className="card  my-4">
                            <div className="card-img-wrapper m-2">
                                <img className="card-img-top" src="https://i.ibb.co/CQY7WZ6/calculator.png" alt="Card cap" rel="noreferrer"/>
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">Basic Calculator</h5>
                                <div className="card-content">
                                    <p className="card-text">A single page web application for simple calculator</p>
                                    <a href="https://github.com/saakeeb/simpleCalculator" class="btn btn-primary p-2 m-2" target="_blank" rel="noreferrer">Server</a>
                                    <a href="https://saakeeb.github.io/simpleCalculator/" class="btn btn-primary p-2 m-2" target="_blank" rel="noreferrer">Website</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <br/> */}

                <div className="col-md-4 col-sm-8 card-wrapper">
                    <div data-aos="fade-left" data-aos-delay="20" data-aos-duration="1000" data-aos-easing="ease-in-sine">
                        <div className="card  my-4">
                            <div className="card-img-wrapper m-2">
                                <img className="card-img-top" src="https://i.ibb.co/z2R53L4/security-pin.png" alt="Card cap" />
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">Security authentication</h5>
                                <div className="card-content">
                                    <p className="card-text">A single page web application for security code match for authentication </p>
                                    <a href="https://github.com/saakeeb/pin-match-master" class="btn btn-primary p-2 m-2" target="_blank" rel="noreferrer">Server</a>
                                    <a href="https://saakeeb.github.io/pin-match-master/" class="btn btn-primary p-2 m-2" target="_blank" rel="noreferrer">Website</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-4 col-sm-8 card-wrapper">
                    <div data-aos="fade-left" data-aos-delay="20" data-aos-duration="1500" data-aos-easing="ease-in-sine">
                        <div className="card  my-4">
                            <div className="card-img-wrapper m-2">
                                <img className="card-img-top" src="https://i.ibb.co/1sMhqnb/number-guessing.png" alt="Card  cap" rel="noreferrer" />
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">Guessing Game</h5>
                                <div className="card-content">
                                    <p className="card-text">A single page web application game for guessing number with bot</p>
                                    <a href="https://github.com/saakeeb/number-guesser" class="btn btn-primary p-2 m-2" target="_blank" rel="noreferrer">Server</a>
                                    <a href="https://saakeeb.github.io/number-guesser/" class="btn btn-primary p-2 m-2" target="_blank" rel="noreferrer">Website</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-4 col-sm-8 card-wrapper">
                    <div data-aos="fade-left" data-aos-delay="20" data-aos-duration="2000" data-aos-easing="ease-in-sine">
                        <div className="card  my-4">
                            <div className="card-img-wrapper m-2">
                                <img className="card-img-top" src="https://i.ibb.co/6v9zgMt/hot-gadgets.png" alt="Card cap" rel="noreferrer" />
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">Gadgets Store</h5>
                                <div className="card-content">
                                    <p className="card-text">A single page e-commerce web application with bootstrap </p>
                                    <a href="https://github.com/saakeeb/hot-gadgets" class="btn btn-primary p-2 m-2" target="_blank" rel="noreferrer">Server</a>
                                    <a href="https://saakeeb.github.io/hot-gadgets/" class="btn btn-primary p-2 m-2" target="_blank" rel="noreferrer">Website</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ParticlesBg num={20} type="cobweb" bg={true} />
        </>
    );
};

export default Projects;